import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["classNames", "suggestions", "isLoading", "refine", "skeletonCount", "itemComponent", "headerComponent", "emptyComponent"];
import { cx } from "../lib/index.js";
import { createButtonComponent } from "./Button.js";
import { SparklesIcon } from "./chat/icons.js";
export function createFilterSuggestionsComponent(_ref) {
  var createElement = _ref.createElement;
  var Button = createButtonComponent({
    createElement: createElement
  });
  function DefaultHeader(_ref2) {
    var classNames = _ref2.classNames;
    return createElement("div", {
      className: cx('ais-FilterSuggestions-header', classNames.header)
    }, createElement("span", {
      className: cx('ais-FilterSuggestions-headerIcon', classNames.headerIcon)
    }, createElement(SparklesIcon, {
      createElement: createElement
    })), createElement("span", {
      className: cx('ais-FilterSuggestions-headerTitle', classNames.headerTitle)
    }, "Filter suggestions"));
  }
  function DefaultItem(_ref3) {
    var suggestion = _ref3.suggestion,
      classNames = _ref3.classNames,
      refine = _ref3.refine;
    return createElement(Button, {
      variant: "outline",
      size: "sm",
      className: cx(classNames.button),
      onClick: refine
    }, createElement("span", {
      className: cx('ais-FilterSuggestions-label', classNames.label)
    }, suggestion.label, ": ", suggestion.value), createElement("span", {
      className: cx('ais-FilterSuggestions-count', classNames.count)
    }, suggestion.count));
  }
  return function FilterSuggestions(userProps) {
    var _userProps$classNames = userProps.classNames,
      classNames = _userProps$classNames === void 0 ? {} : _userProps$classNames,
      suggestions = userProps.suggestions,
      isLoading = userProps.isLoading,
      _refine = userProps.refine,
      _userProps$skeletonCo = userProps.skeletonCount,
      skeletonCount = _userProps$skeletonCo === void 0 ? 3 : _userProps$skeletonCo,
      _userProps$itemCompon = userProps.itemComponent,
      ItemComponent = _userProps$itemCompon === void 0 ? DefaultItem : _userProps$itemCompon,
      headerComponent = userProps.headerComponent,
      EmptyComponent = userProps.emptyComponent,
      props = _objectWithoutProperties(userProps, _excluded);
    var HeaderComponent = headerComponent === false ? null : headerComponent !== null && headerComponent !== void 0 ? headerComponent : DefaultHeader;
    var isEmpty = suggestions.length === 0;
    if (isEmpty && !isLoading) {
      return createElement("div", _extends({}, props, {
        className: cx('ais-FilterSuggestions', classNames.root, 'ais-FilterSuggestions--empty', classNames.emptyRoot, props.className)
      }), EmptyComponent && createElement(EmptyComponent, {
        classNames: {
          emptyRoot: classNames.emptyRoot
        }
      }));
    }
    var headerClassNames = {
      header: classNames.header,
      headerIcon: classNames.headerIcon,
      headerTitle: classNames.headerTitle
    };
    var itemClassNames = {
      item: classNames.item,
      button: classNames.button,
      label: classNames.label,
      count: classNames.count
    };
    return createElement("div", _extends({}, props, {
      className: cx('ais-FilterSuggestions', classNames.root, isLoading && cx('ais-FilterSuggestions--loading', classNames.loadingRoot), props.className)
    }), HeaderComponent && createElement(HeaderComponent, {
      classNames: headerClassNames
    }), isLoading ? createElement("div", {
      className: cx('ais-FilterSuggestions-skeleton', classNames.skeleton)
    }, _toConsumableArray(new Array(skeletonCount)).map(function (_, i) {
      return createElement("div", {
        key: i,
        className: cx('ais-FilterSuggestions-skeletonItem', classNames.skeletonItem)
      });
    })) : createElement("ul", {
      className: cx('ais-FilterSuggestions-list', classNames.list)
    }, suggestions.map(function (suggestion) {
      return createElement("li", {
        key: "".concat(suggestion.attribute, "-").concat(suggestion.value),
        className: cx('ais-FilterSuggestions-item', classNames.item)
      }, createElement(ItemComponent, {
        suggestion: suggestion,
        classNames: itemClassNames,
        refine: function refine() {
          return _refine(suggestion.attribute, suggestion.value);
        }
      }));
    })));
  };
}